import React from 'react';
import { t } from '@lingui/macro';

import { Box, Image } from '@rover/kibble/core';

import { AVATAR_SIZE, DEFAULT_IMAGE } from './Avatar.constants';
import { AvatarType, Props } from './Avatar.types';

function getSource(src: string | null | undefined, type: string | undefined): string {
  if (!!src && !src.endsWith('.svg')) return src;
  return type ? DEFAULT_IMAGE?.[type] : DEFAULT_IMAGE.other;
}

export function toAvatarType(str: string): AvatarType {
  switch (str.toLowerCase()) {
    case 'dog':
      return 'dog';
    case 'cat':
      return 'cat';
    default:
      return 'other';
  }
}

const Avatar = (props: Props): JSX.Element => {
  const { imageUrl, alt, type = 'person', size = 'default', shape = 'circle', sx, ...rest } = props;
  return (
    <Box
      height={shape === 'rounded' ? '100%' : AVATAR_SIZE[size]}
      width={shape === 'rounded' ? '100%' : AVATAR_SIZE[size]}
      borderRadius={shape === 'circle' ? 'round' : 'primary'}
      sx={{ position: 'relative', overflow: 'hidden', ...sx }}
      {...rest}
    >
      <Image
        src={getSource(imageUrl, type)}
        description={alt || t`Profile image`}
        width="100%"
        height="100%"
      />
    </Box>
  );
};

export default Avatar;
